import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Link, RowContainer } from '../../shared/styles';
import { ActionColumn, DateColumn, NameColumn } from './styles';
import { deleteAdvertising } from '../../../../services/lwadmin/advertising/advertising-service';
import useAdvertisingsStore from './state-hook';

const DeleteLink = styled(Link)`
  color: ${props => props.theme.errorColor};

  &:hover {
    color: ${props => props.theme.errorColor};
  }
`;

export default function Advertising({ advertising }) {
  const removeAdvertising = useAdvertisingsStore(state => state.removeAdvertising);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = React.useState(false);

  const {
    id,
    name,
    startDate,
    finishDate,
  } = advertising;

  const handleDelete = e => {
    e && e.preventDefault();

    deleteAdvertising(id).then(removeAdvertising(advertising));
  };

  return (
    <RowContainer>
      <NameColumn>{name}</NameColumn>
      <DateColumn>{moment(startDate).format('DD/MM/YY')}</DateColumn>
      <DateColumn>{moment(finishDate).format('DD/MM/YY')}</DateColumn>
      <ActionColumn>
        {!showDeleteConfirmation
          ? (
            <>
              <Link href={`/lwadmin/advertising/${id}/edit`}>Edit</Link>
              |
              <DeleteLink href="#" onClick={() => setShowDeleteConfirmation(true)}>Delete</DeleteLink>
            </>
          )
          : (
            <>
              <DeleteLink href="#" onClick={handleDelete}>Confirm Delete</DeleteLink>
              |
              <Link href="#" onClick={() => setShowDeleteConfirmation(false)}>Cancel</Link>
            </>
          )}
      </ActionColumn>
    </RowContainer>
  );
}

Advertising.propTypes = {
  advertising: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    finishDate: PropTypes.string.isRequired,
  }).isRequired,
};
